/**
 * Free-trial constants + helpers shared by pricing, paywall and checkout UI.
 *
 * Every new Coach AI subscription starts with a TRIAL_DAYS free trial
 * (`trial_period_days` on the Stripe subscription), so nothing is charged
 * until the trial ends. Keep this number in sync with the edge functions
 * `create-checkout` and `create-subscription-checkout`.
 */
export const TRIAL_DAYS = 7;

export const TRIAL_LABEL = "seven day free trial";

/** Date billing starts if the user subscribes right now. */
export function trialEndDate(from: Date = new Date()): Date {
  const d = new Date(from);
  d.setDate(d.getDate() + TRIAL_DAYS);
  return d;
}

/** e.g. "Thu 6 Aug" — short, human readable. */
export function formatTrialEnd(date: Date = trialEndDate()): string {
  return date.toLocaleDateString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
}

/** Sentence used across pricing/paywall/checkout screens. */
export function trialBillingNote(date: Date = trialEndDate()): string {
  return `Free until ${formatTrialEnd(date)} — billing starts then. Cancel anytime before that and you won't be charged.`;
}
